import { useQuery } from '@tanstack/react-query';
import { readPapel } from './papeis.service';

export function usePapeis(skip = 0, take = 1000) {
  return useQuery({
    queryKey: ['papeis', skip, take],
    queryFn: () => readPapel(skip, take),
    staleTime: 1000 * 60 * 10, // cache 10min
  });
}
